export const dialog1 = [
	{
		"keywords": "Bild(er)/Bilda/Foto(s)/Photos/Pic(s)",
		"reply": "@{user}: Ist es das, was du sehen willst? {hard_pic}",
		used: false,
	},
	{
		"keywords": "Zeig ma(l)/Lass ma(l) sehen/schick ma(l)",
		"reply": "@{user}: Ist es das, was du sehen willst? {hard_pic}",
		used: false,
	},
	{
		"keywords": "Titten/Brüste(n)/Boobs/Glocken/Busen/Dinger/Möp(p)se/Kurven/Hupen",
		"reply": "@{user}: Gefallen dir meine? ;-) {tits_pic}",
		used: false,
	},
	{
		"keywords": "Hintern/Arsch/Ärsche/Hinterteil/Po/Popo",
		"reply": "@{user}: Hier hast du ihn {ass_pic}",
		used: false,
	},
	{
		"keywords": "Action/Aktion/in Bewegung/shaken",
		"reply": "@{user}: Du willst also mehr Action haben was? :-P Sollst du haben {video}",
		used: false,
	},
	{
		"keywords": "beobachten/live/Kamera/Cam/Webcam/ungestört/allein/privat",
		"reply": "@{user}: Klar doch Süßer! Findest meine Cam hier: {profile_link} Da sind wir ganz unter uns :-D",
		used: false,
	},
	{
		"keywords": "Wo finde ich dich?/Wo kann man dich sehen?",
		"reply": "@{user}: Ich warte vor meiner Cam auf dich. Komm bitte schnell vorbei, bin schon ein bisschen feucht ;-) {profile_link}",
		used: false,
	},
	{
		"keywords": "Pussy/Pussi/Muschi/Mumu/Vagina/Scheide/Fotze/Möse",
		"reply": "@{user}: Na du gehst aber ran ;-) Die zeig ich hier aber nicht jedem! Dann komm mal in meine Cam {profile_link} Da pack ich sie ganz exclusiv für dich aus :-P",
		used: false,
	},
	{
		"keywords": "Anal/von hinten/Hintertür",
		"reply": "@{user}: würdest ihn hier gerne mal reinstecken? {ass_pic}",
		used: false,
	},
	{
		"keywords": "fessel(n)/knebel(n)/peitsche(n)/Sklav(e/in)/dominant/devot/Pipi/Natursekt/Füße",
		"reply": "@{user}: auf solche Spielchen stehst du also? Ich bin da sehr experimentierfreudig :-P wollen wirs mal zusammen testen?",
		used: false,
	},
	{
		"keywords": "Latte/harten/steifen/Erektion/Knüppel/erregt",
		"reply": "@{user}: soll ich mich da mal drum kümmern? ;-) ich hab da so einige ideen was ich mit ihm anstellen würde :-D",
		used: false,
	},
	{
		"keywords": "Stadt/wohnst/woher kommst du/Ort",
		"reply": "@{user}: das möchte ich hier nicht so gerne verraten. Ist ja zum Glück dank webcam auch nicht so wichtig, kann man ja auch ne Menge Spaß haben ;-) Oder findest du nicht? Hattest du schon mal einen Camchat?",
		used: false,
	},
	{
		"keywords": "neu für mich/Neuling/Newbie/zum ersten Mal/erstes Mal/keine Erfahrung",
		"reply": "@{user}: :-D das macht nix…kann dich gerne einführen *hihi* Magst du mal in meinen Camchat kommen? Ist ein bisschen privater als hier {profile_link}",
		used: false,
	},
	{
		"keywords": "Wie alt/Alter",
		"reply": "@{user}: nana…sowas fragt man doch eine lady nicht ;-) und ist das denn so wichtig?",
		used: false,
	},
	{
		"keywords": "Instagram/Facebook/Whatsapp/Telegram/Email/E-Mail/Telefon/telefonieren/mailen/Snapchat/TikTok",
		"reply": "@{user}: geb ich nicht so gerne gleich raus, aber du kannst gerne in meinen camchat kommen oder mich anschreiben. Schau mal hier {profile_link}",
		used: false,
	}
]
